import React, {useMemo, useState} from 'react';
import assert from 'assert-ts';
import {Concept} from 'types';
import {useLocalization} from 'localization';
import {useCreateBulkUpdate} from 'services/bulkUpdateItems';
import {useCodelist} from 'services/codelists';
import {ActionButtonV2} from 'components/button/ActionButtonV2';
import {useAdvancedSearchContext} from '../context/AdvancedSearchContext';

export const StartBulkUpdate = () => {
  const {t} = useLocalization();
  const bulkUpdateTypes = useCodelist('bulkUpdateType');
  const [startBulkUpdateProgress, setStartBulkUpdateProgress] =
    useState<number>(0);
  const {
    getMetadataIdsPage,
    viewMode,
    dataResponse,
    loadingSearch,
    loadingDownload,
    loading,
  } = useAdvancedSearchContext();

  const canBulkUpdate = useMemo(() => {
    return (
      !loading &&
      !loadingSearch &&
      !loadingDownload &&
      dataResponse.hits > 0 &&
      // We don't have bulkUpdate on manifestations yet
      viewMode === Concept.work
    );
  }, [dataResponse.hits, loading, loadingDownload, loadingSearch, viewMode]);

  const startBulkUpdate = useCreateBulkUpdate(
    viewMode,
    dataResponse.hits,
    getMetadataIdsPage,
    (total, _, progress) => {
      setStartBulkUpdateProgress(Math.floor(100 * (progress / total)));
    },
  );

  const viewModelLabel = useMemo(() => {
    return assert(
      bulkUpdateTypes.codes.find(c => c.code === viewMode)?.value,
      'Exepected known bulkUpdateType/viewmode',
      {viewMode, bulkUpdateTypes},
    ).toLowerCase();
  }, [bulkUpdateTypes, viewMode]);

  return (
    <ActionButtonV2
      icon={'Edit'}
      size={'medium'}
      variant={'text'}
      disabled={!canBulkUpdate}
      onClick={startBulkUpdate}
      showSpinnerOnClick
      title={
        startBulkUpdateProgress === 0
          ? t('page.bulkUpdate.start.label')
          : t('page.bulkUpdate.start.progress', {
              type: viewModelLabel,
              progress: `${startBulkUpdateProgress}%`,
            })
      }
    />
  );
};
